// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"dfba065c","511":"e57ae850","905":"fa1869f7"}[chunkId] + ".chunk.js";
};